<template>
    <div class="home">
        <my-header></my-header>
        <!-- 导航 -->
        <el-row :span="24" class="bg-color">
            <!-- <el-col :span="4" :sm="4"><div>&nbsp;</div></el-col> -->
            <el-col :xs="{span:22,offset:1}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <nav class="nav">
                    <ul>
                        <li v-for="(list,index) in navList"  :class="{ active:changeRed == index}"  :key="index" @click="active(index)">{{list.text}}</li>
                    </ul>
                </nav>
            </el-col>
            <!-- <el-col :span="4" :sm="4"><div>&nbsp;</div></el-col> -->
        </el-row>
        <!-- 正文 -->
        <el-row class="container"   >
            <el-col :span="2" :xs="{span:2}" ><div>&nbsp;</div></el-col>
            <el-col :span="16" :xs="20">
                <div class="container_lsgw">
                    <div class="le_top " :xs="{span:20}" :sm="{span:20,offset:2}" :md="{span:16,offset:4}" >
                        <!-- 顾问 -->
                        <div class="carousel"  >
                            <div class="adviser"><i class="el-icon-s-grid"></i>顾问 <span>Adviser</span> </div>
                            <!-- <div class="adviser_right">MORE >></div> -->
                            <div class="line_h"></div>
                            <el-carousel  indicator-position="none" height="150px" :autoplay="true" :interval="6000">
                                <el-carousel-item v-for="item in Adviser" :key="item.id">
                                    <img :src="item.pictureurl" alt="加载中">
                                    <!-- <p></p> -->
                                    <pre>{{ item.describeC }}</pre>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <!-- 理事 -->
                        <div class="le-ls">
                            <div class="carousel">
                                <div class="adviser"><i class="el-icon-s-grid"></i>理事 <span>Director</span> </div>
                                <!-- <div class="adviser_right">MORE >></div> -->
                                <div class="line_h"></div>
                                <el-carousel  indicator-position="none" height="150px" :autoplay="true" :interval="6000">
                                    <el-carousel-item v-for="item in Lishi" :key="item.id">
                                        <img :src="item.pictureurl" alt="" >
                                        <!-- <p>{{ item.describeC }}</p> -->
                                        <pre>{{ item.describeC }}</pre>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </div>
                    </div>
                    <!-- 项目公式 -->
                    <div class="list_pro">
                        <div class="pro_item">
                            <div class="pro_title"> <i class="el-icon-document-remove"></i> 投资融资,招标项目公示 <span style="display:inline-block;font-weight:normal;color:#d6d6d6;margin-left:10px;font-size:18px;">Project Publicity</span></div>
                            <div class="pro_h"></div>
                        </div>
                        <ul class="pro_list">
                            <li v-for="(item,k) in projectShow" :key="k"
                                @click="goGetdetail(item.mykey)"
                            >
                                <img :src="item.articalImg" alt="">
                                <div>{{item.articalTitle}}</div>
                            </li>
                        </ul>
                    </div>
                    <!-- 新闻 资讯 开始 -->
                    <div class="le_news">
                        <div class="news" :xs="{span:20}" >
                            <div class="new_title">
                                <span> <i class="el-icon-notebook-2"></i> 新闻</span>
                                <span>NEWS</span>
                            </div>
                            <div class="line_n"></div>
                            <ul v-for="(item,index) in newList" :key="index" @click="goGetdetail(item.mykey)" >
                                
                                <li><img :src="item.img" alt="加载中"></li>
                                <li><span v-show="item.top == 0 ">置顶</span> {{item.title}}</li>
                                <li>{{item.context}}</li>
                            </ul>
                        </div>
                        <div class="info"  :xs="{span:20}"  >
                            <div class="info_title">
                                <span> <i class="el-icon-notebook-1"></i> 资讯</span>
                                <span>INFORMATION</span>
                            </div>
                            <div class="line_i"></div>
                            <ul v-for="(list,index) in infoList" :key="index" @click="goGetdetail(list.mykey)" >
                                <li><img :src="list.img"  :onerror="defaultImg"></li>
                                <li><span v-show="list.top ==0 ">置顶</span> {{list.title}} </li>
                                <li>{{list.context}}</li>
                            </ul>
                        </div>
                        <el-button type="info" @click="showMore()" v-if="!(shownew&&showinfo)" >加载更多<i class="el-icon-arrow-right"></i></el-button>
                        <el-button type="info" v-if="shownew&&showinfo" >没有更多了</el-button>
                    </div>
                </div>
                <div v-for="(item,k) in footerImg" :key="k"  >
                    <span style="display:block;font-weight:bold;font-size:15px;box-sizing:border-box;padding:6px 0;border-bottom:1px solid #eee;margin-bottom:10px;">友情连接</span>
                    <!-- <div style="width:100%;height:1px;background-color:#eee;"></div> -->
                    <a :href="item.linkurl" target="_blank"><img :src="item.pictureurl" class="footimg"></a>
                </div>
            </el-col>
            <el-col :span="4" class="hidden-xs-only">
                <div class="container_fwzx">
                    <ul>
                        <span><i class="el-icon-s-custom"></i>服务中心</span>
                        <li v-for="(list,index) in rightList" :key="index" @click="change(index)" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)"><i class="el-icon-remove-outline"></i>{{list.text}}</li>
                    </ul>
                </div>
                <div class="advert" v-for="(img,m) in Advert" :key="m">
                    
                    <a :href="img.adJump"><img  :src="img.adUrl" alt="img" :click="img.adJump" ></a>    
                    
                </div>
            </el-col>
            <el-col v-if="showSee">
                <div class="md_fwzx">
                    <ul>
                        <span><i class="el-icon-s-custom"></i>服务中心</span>
                        <li v-for="(list,index) in rightList" :key="index" @click="change(index)" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)"><i class="el-icon-remove-outline"></i>{{list.text}}</li>
                    </ul>
                </div>
                
            </el-col>
            <el-col :span="2" :xs="{span:2}"></el-col>
        </el-row>
        <my-footer></my-footer>
        
    </div>
</template>

<script>
import MyHeader  from '@/components/headerPage'
import MyFooter  from '@/components/footerPage'
import MyLeval from '@/components/ZH-CN/jjgkPage'
import MyMember from '@/components/ZH-CN/memberPage'

export default {
    components:{ MyHeader,MyLeval,MyMember,MyFooter},
    name: 'homePage',
    data () {
        return {
            defaultImg: require('../../assets/error.jpg'),
            changeRed:0,
            navList:[{
                text:"首页"
            },{
                text:"简介概况"
            },{
                text:"会员中心"
            },{
                text:"联系我们"
            }],
            
            rightList:[{
                text:'法律事务'
            },{
                text:"物流服务"
            },{
                text:"融资投资"
            },{
                text:"租赁共享"
            },{
                text:"峰会展览"
            },{
                text:"商务考察"
            },{
                text:"翻译公证"
            },{
                text:"人才交流"
            },{
                text:"慈善文化"
            },{
                text:"互助基金"
            },{
                text:"财务管理"
            },{
                text:"政策宣传"
            },{
                text:"投融资项目公示"
            }],
            changes:0,
            newList:[], //新闻 
            infoList:[],  //资讯
            Advert:[], //广告
            showSee:false,

            page:1,
            pageSize:5,

            paged:1,
            pagedSize:5,

            shownew:false,
            showindo:false,

            Lishi:[],
            Adviser:[],
            footerImg:[],

            projectShow:[], // 项目公式
        }
    },
    mounted() {
        this.newsList(); //新闻资讯
        this.infosList();
        this.homeAdvert();
        var w = document.documentElement.clientWidth;
        if(w < 768){
            this.showSee = true
        }else{
            this.showSee = false
        }
        this.getAdviser();
        this.getLishi();
        
        // window.addEventListener("scroll", this.scrollBottom);
        this.getFooterimg();

        this.getProshow();
    },
    methods: {
        
        scrollBottom(){
         //scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
        //     //windowHeight是可视区的高度
           var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //     //scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
        //     //滚动条到底部的条件
        
          if(scrollTop+windowHeight==scrollHeight){
                this.page++
                this.paged++
                this.newsList();
                this.infosList();
            }
        },
        showMore(){
            this.page++
            this.paged++
            this.newsList();
            this.infosList();
        },
        //移入事件
        changeActive($event){
            $event.currentTarget.className="Act"
        },
        //移出
        removeActive($event){
             $event.currentTarget.className="";
        },

        newsList(){
            this.$axios.get('/getNewsPages/'+this.page+'/'+this.pageSize).then(res=>{
                if(res.data.success){
                    this.newList = this.newList.concat(res.data.data.list);
                    if(this.page>res.data.data.list.length){
                        this.shownew= true;
                    }
                }
                
            })
        },
        infosList(){
            this.$axios.get('/getInformationPages/'+this.paged+'/'+this.pagedSize).then(res=>{
                if(res.data.success){
                    this.infoList =  this.infoList.concat(res.data.data.list);
                    if(this.page>res.data.data.list.length){
                        this.showinfo= true;
                    }
                }
                
            })
        },
        // newsList(){
        //     this.$axios.get('/getNewsAndInformation').then(res=>{
        //         if(res.data.success){
        //             var resList = res.data.data
        //         this.newList = resList.news
        //         this.infoList =resList.informations
        //         }
                
        //     })
           
        // },
        homeAdvert(){
            this.$axios.get('/getAds').then(res=>{
                if(res.data.success){
                    this.Advert = res.data.data
                }
                
            })
        },
        active(index){
            this.changeRed = index;
            if(index == 0){
                this.$router.push({name:"homePage"})
            }else if(index == 1){
                this.$router.push({name:"surveyPage"})
            }else if(index == 2){
                this.$router.push({name:"memberPage"})
            }else if(index == 3){
                this.$router.push({name:"aboutPage"})
            }
        },
        change(index){
            this.$router.push({ name: 'levalPage',params:{changes:index+1}})
            this.changes = index;
        },
        //新闻 或资讯 去详情
        goGetdetail(mykey){
            this.$axios.get('/getIndexDetail/'+mykey).then(res=>{
                let resList = res.data.data;
                this.$router.push({ path: '/detail',query:{art:resList}})
            })
        },

        //顾问 轮播
        getAdviser(){
            this.$axios.get('/getAdviser/1').then(res=>{
                if(res.data.success){
                    this.Adviser = res.data.data;
                }
            })
        },
        getLishi(){
            this.$axios.get('/getAdviser/0').then(res=>{
                if(res.data.success){
                    this.Lishi = res.data.data;
                }
            })
        },
        getFooterimg(){
            this.$axios.get('/getLinks').then(res=>{
                if(res.data.success){
                    // console.log(res.data);
                    this.footerImg = res.data.data;
                }
            })
        },
        //项目公式
        getProshow(){
            this.$axios.get('/getProjectShows').then(res=>{
                if(res.data.success){
                    // console.log(res.data);
                    this.projectShow = res.data.data;
                }
            })
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
    
    .bg-color{
        background-color: #DBDBDB;
    }
    .nav{
        width:100%;
        height:auto;
        background-color: #DBDBDB;
    }
    .nav ul li {
        float:left;
        width:25%;
        /* line-height:40px; */
        box-sizing: border-box;
        padding:10px 10px;
        color:#5B5B5B;
        font-size:20px;
        font-weight:600;
        text-align: center;
        cursor:pointer;
    }
    .nav ul li.active{
        color:#fff;
        background-color: #1f3356;
    }



    
    .container_lsgw{
        width:96%;
        height:auto;
        margin-top:40px;
    }
    

    /* 服务中心 */
    .container_fwzx{
        width:100%;
        height:auto;
        margin-top:40px;
    }
    .container_fwzx ul{
        width:80%;
        height:auto;
        margin:0 auto;
        border:1px solid #ececec;
    }
    .container_fwzx ul span{
        display:block;
        width:100%;
        height:auto;
        min-height:46px;
        font-size:20px;
        text-align: center;
        line-height:46px;
        color:#fff;
        background-color: #1e3557;
    }
    .container_fwzx ul li{
        width:90%;
        height:40px;
        text-align: left;
        line-height:40px;
        margin:22px auto;
        border-radius: 6px;
        color:#1e3557;
        cursor:pointer;
        background-color: #ededed;
    }
    .container_fwzx ul i{
        color:#d3d3d3;
        box-sizing: border-box;
        padding:0 10px 0 20px;
    }
    .container_fwzx ul li.Act{
        background-color: #FE9900;
        color:#fff;
    }
    /* 手机端 服务中心 在底部 */
    .md_fwzx{
        width:100%;
        height:auto;
    }
    .md_fwzx ul{
        float: left;
        /* width:100%; */
        margin:0 auto;
        border:1px solid #ececec;
    }
    .md_fwzx ul span{
        display:block;
        width:100%;
        font-size:20px;
        text-align: center;
        line-height:46px;
        color:#fff;
        background-color: #1e3557;
    }
     .md_fwzx ul li{
        float: left;
        height:40px;
        text-align: left;
        line-height:40px;
        margin:22px 10px;
        border-radius: 6px;
        color:#1e3557;
        box-sizing: border-box;
        padding:0 10px;
        cursor:pointer;
        background-color: #ededed;
    }
    .md_fwzx ul i{
        color:#d3d3d3;
        box-sizing: border-box;
        padding:0 4px 0 4px;
    }
    .md_fwzx ul li.Act{
        background-color: #FE9900;
        color:#fff;
    }
    /* 手机端 服务中心 在底部 */
    /*  */
    .carousel .adviser{
        float: left;
        /* margin:10px 0; */
        font-size:28px;
        font-weight:600;
        color:#1d3456;
        box-sizing: border-box;
        padding:6px 0;
        /* border-bottom:1px solid #000; */
    }
    .carousel .adviser span{
        font-size:16px;
        color:#999;
    }
    
    .carousel .line_h{
        
        width:100%;
        height:1px;
        padding-top:2px;
        background-color: #ddd;
        margin:10px 0;
        clear:both;
    }
     .carousel  img{
        display: block;
        float:left;
        width: 300px;
        height:200px;
        margin-right:20px;
    }
    .carousel  p{
        font-size:18px;
        box-sizing: border-box;
        padding:20px 0;
        color:#333;
        cursor:default;
    }
    /* .carousel .el-carousel__arrow{
        display:none;
    }
    .carousel .el-carousel__indicator button{
        width:10px !important;
        height:10px !important;
        border-radius: 50%;

    } */
    .le_top .le-ls{
        margin-top:22px;
    }

    .le_news{
        margin-top:80px;
    }
    .le_news .el-button{
        margin-left:40%;
        margin-top:20px;
        background-color: #4C70AC;
        width:200px;
        height:50px;
    }
    .le_news .news{
        float: left;
        width:44%;
        height:auto;
        margin-right:10%;
    }
    .le_news .news .new_title{
        width:100%;
    }
    .le_news .news .new_title span:nth-child(1){
        display:block;
        float:left;
        width:20%;
        height:50px;
        text-align: center;
        line-height:50px;
        color:#000;
        font-size:20px;
        font-weight:600;
        /* background-color: #1c3458; */
    }
    .le_news .news .new_title span:nth-child(2){
        display:block;
        float:left;
        width:70%;
        height:50px;
        box-sizing: border-box;
        padding:0 20px;
        line-height:50px;
        color:#d6d6d6;
        font-size:22px;
    }
    .le_news .news .line_n{
        float:left;
        width:100%;
        height:2px;
        margin-bottom:10px;
        background-color: #1f3358;
        
    }
    .le_news .news ul{
        clear: both;
        width:100%;
        height:120px;
    }
    .le_news .news ul:hover{
        /* box-shadow: 0 0 10px #999; */
        transform: scale(0.95);
        /* color:#f00; */
        /* border-radius: 10px; */
    }
    .le_news .news ul li img{
        display:block;
        float: left;
        width:120px;
        height:110px;
        box-sizing: border-box;
        padding-right:12px;
        cursor:pointer;
    }
    .le_news .news ul li {
        box-sizing: border-box;
        /* padding:4px 0; */
        font-size:20px;
        margin:10px 0;
        cursor:default;
    }
    .le_news .news li span{
        
        width:50px;
        height:20px;
        font-size:14px;
        color:#fff;
        background-color: #fe9900;
    }
    .le_news .news ul li:nth-child(2){
        color:#333;
        font-weight:600;
        /* box-sizing: border-box;
        padding-top:6px; */
        overflow: hidden;
        white-space: nowrap;
        text-overflow:ellipsis;
    }
    .le_news .news ul li:nth-child(2):hover{
        color:#f00;
    }
    .le_news .news ul li:nth-child(3){
        color:#999;
        /* box-sizing: border-box;
        padding-top:8px; */
        cursor:pointer;
        font-size:16px;
        color:#999;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    /* 资讯 */
    .le_news .info{
        float: left;
        width:44%;
        height:auto;
    }
    .le_news .info .info_title{
        width:100%;
    }
    .le_news .info .info_title span:nth-child(1){
        display:block;
        float:left;
        width:20%;
        height:50px;
        text-align: center;
        line-height:50px;
        color:#000;
        font-size:20px;
        font-weight:600;
        /* background-color: #ff9900; */
    }
    .le_news .info .info_title span:nth-child(2){
        display:block;
        float:left;
        width:70%;
        height:50px;
        box-sizing: border-box;
        padding:0 20px;
        line-height:50px;
        color:#d6d6d6;
        font-size:22px;
    }
    .le_news .info .line_i{
        float:left;
        width:100%;
        height:2px;
        margin-bottom:10px;
        background-color: #000;
        /* background-color: #ff9900; */
        
    }
    .le_news .info ul{
        clear: both;
        width:100%;
        height:120px;
    }
    .le_news .info ul:hover{
        transform: scale(0.95);
    }
    
    .le_news .info img{
        display:block;
        float: left;
        width:110px;
        height:110px;
        margin-right:10px;
        cursor:pointer;
    }
    .le_news .info ul li {
        box-sizing: border-box;
        /* padding:4px 0; */
        font-size:20px;
        margin:10px 0;
        cursor:default;
    }
    .le_news .info li span{
        width:50px;
        height:20px;
        font-size:14px;
        color:#fff;
        background-color: #fe9900;
    }
    .le_news .info ul li:nth-child(2){
        color:#333;
        /* box-sizing: border-box;
        padding-top:6px; */
        font-weight:600;
        overflow: hidden;
        white-space: nowrap;
        text-overflow:ellipsis;
    }
    .le_news .info ul li:nth-child(2):hover{
        color:#F00;
    }
    .le_news .info ul li:nth-child(3){
        color:#999;
        /* box-sizing: border-box;
        padding-top:8px; */
        font-size:17px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    /* 广告图片 */
    .advert{
        width:100%;
        height:auto;
    }
    .advert img{
        display:block;
        width:80%;
        height:140px;
        margin:12px auto;
        /* margin-bottom:10px; */
    }

    .footimg{
        display: block;
        width:100px;
        height:50px;
    }

    /* 项目公式 */
    .list_pro{
        width:100%;
        height:auto;
        min-height:300px;
        margin:40px 0;
    }
    .pro_item{
        width:98%;
        height:auto;
        margin:14px 0;
    }
    .pro_item .pro_title{
        color:#000;
        font-size:22px;
        font-weight:600;
        box-sizing: border-box;
        padding:0 20px;
    }
    .pro_item .pro_h{
        margin-top:16px;
        border-bottom:3px solid #000;
    }
    .pro_img{
        width:100%;
        height:160px;
        text-align:center;
        line-height:160px;
        color:#fff;
        font-size:30px;
        background-color:#1f3356;
    }
    .pro_list{
        float:left;
        width:100%;
        height:auto;
        min-height:320px;
    }
    .pro_list li{
        float:left;
        width:31%;
        height:320px;
        margin-right:20px;
    }
    .pro_list li img{
        float:left;
        display:block;
        width:100%;
        height:240px;
    }
    .pro_list li div{
        float: left;
        width:100%;
        height:50px;
        line-height:50px;
        box-sizing: border-box;
        padding:0 10px;
        font-size:22px;
        font-weight:bold;
        z-index: 10;
        color:#fff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background-color:#1f3356;
    }
</style>



// WEBPACK FOOTER //
// src/components/ZH-CN/homePage.vue